export const SET_TOKEN_RECAPTCHA = "CRACHA_AMBULANTE_SET_TOKEN_RECAPTCHA";
export const SAVE = "CRACHA_AMBULANTE_SAVE";
